import { createContext } from 'react';

const RestaurantContext = createContext();

export default RestaurantContext;